module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-31-2bbbc0cbfc7f70d39b2cdd4e9e66b2bb.jpg";